module.exports = __webpack_public_path__ + "static/media/trash-2.e762cb11.svg";